import httpauth from "@/services/httpauth.js";

const api = {
  getCategoryMedical() {
    return httpauth.get('/category-medical');
  },

  getPatology() {
    return httpauth.get('/patology');
  },
  getCompany() {
    return httpauth.get('/companies');
  },
  getAnatomicalDistrict() {
    return httpauth.get('/anatomical-district');
  },
  getUsers() {
    return httpauth.get('/users');
  },
  getUserClinicalCase() {
    return httpauth.get('/users?clinical_case_privacy=1');
  },
  loadComments(activity_id) {
    return httpauth
      .get("/comments/show/" + activity_id, [
        { params: { activity_id: activity_id } },
      ]);
  },
  checkPermission(multiple, section, permission) {
    const form = {
      multiple: multiple,
      section: section,
      permission: permission
    };
    return httpauth
      .post("/check-permission", form);
  },
  getAttachments(model, modelId) {
    var formData = {
      model: model,
      modelId: modelId
    }
    return httpauth.post('/attachments/show', formData);
  },
  uploadAttachments(uploadFiles, modelId, model, returned, multiple_file) {
    const formData = new FormData();

    if (multiple_file == 1)
    {
      uploadFiles.forEach((file) => {
        formData.append("files[]", file);
      });
    } else if (multiple_file == 0)
    {
      formData.append('file', uploadFiles);
    }
    formData.append("model_id", modelId);
    formData.append("model", model);
    formData.append("multiple_file", multiple_file);
    formData.append("returned", returned);

    return httpauth
      .post("/attachments/store", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  },

  uploadCovers(file, model_id, model_type) {
    const formData = new FormData();
    formData.append("model_id", model_id);
    formData.append("model", model_type);
    formData.append('cover', file);
    return httpauth
      .post("/attachments/cover/store", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  },

  deleteAttachment(attachmentId) {
    return httpauth.get('/attachments/delete/' + attachmentId);
  },
  checkDicom(file) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);

    //Fired after sucessful file read, Please read documenation for FileReader
    return reader.onload = function (evt) {
      if (evt.target.readyState === FileReader.DONE)
      {

        var array = new Uint8Array(evt.target.result);
        var s = "";
        var start = 128, end = 132;
        for (var i = start; i < end; ++i)
        {
          s += array[i].toString(16);
        }

        if (s == '4449434d')
        {
          return true;
        }

        else
        {

          return false;
        }
      }
    };
  }
};

export default api;
